import { Controller } from "@hotwired/stimulus"

// Simple show/hide panel. Click the trigger, panel toggles between
// `hidden` and visible. Initial state can be set with
// data-disclosure-open-value="true" on the controller element.
export default class extends Controller {
  static targets = ["panel", "trigger"]
  static values = { open: Boolean }

  connect() {
    if (this.openValue) this.show()
    else this.hide()
  }

  toggle() {
    this.openValue ? this.hide() : this.show()
  }

  show() {
    this.openValue = true
    this.panelTargets.forEach((el) => el.classList.remove("hidden"))
  }

  hide() {
    this.openValue = false
    this.panelTargets.forEach((el) => el.classList.add("hidden"))
  }
}
